module.exports = __webpack_public_path__ + "img/79800.4c372260.jpg";